export default "__VITE_ASSET__C0k5WJxp__"